import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./slice";

const selectDomain = (state) => state.dashboardFilter || initialState;
const alphanumericSort = (a, b) => {
  return a.localeCompare(b, undefined, {
    numeric: true,
    sensitivity: "base",
  });
};
export const selectClients = createSelector([selectDomain], (state) =>
  state.clients
    ?.map((client) => ({
      value: client._id,
      label: client.companyName,
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
);

export const selectProjects = createSelector([selectDomain], (state) =>
  state.projects
    ?.map((project) => ({
      value: project._id,
      label: project.projectCode,
    }))
    .sort((a, b) => alphanumericSort(a.label, b.label))
);

// New selector for commodities
export const selectCommodities = createSelector([selectDomain], (state) =>
  state.commodities
    ?.map((commodity) => ({
      value: commodity.name,
      label: commodity.name,
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
);
// New selector for testing types
export const selectTestingTypes = createSelector([selectDomain], (state) =>
  state.testingTypes
    ?.map((testingType) => ({
      value: testingType.name,
      label: testingType.name,
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
);
// New selector to get raw projects data for filtering logic
export const selectRawProjects = createSelector(
  [selectDomain],
  (state) => state.projects || []
);

// Selector for projects loading state
export const selectProjectsLoading = createSelector(
  [selectDomain],
  (state) => state.projectsLoading || false
);

// Helper function to filter valid projects based on selected clients
export const getValidProjects = (
  selectedProjects,
  selectedClients,
  allProjects
) => {
  if (!selectedClients || selectedClients.length === 0) {
    return [];
  }

  if (!allProjects || allProjects.length === 0) {
    return selectedProjects;
  }

  const validProjectIds = allProjects
    .filter((project) => {
      const clientId = project.companyId?._id || project.companyId;
      return selectedClients.includes(clientId);
    })
    .map((project) => project._id);

  return selectedProjects.filter((projectId) =>
    validProjectIds.includes(projectId)
  );
};

// New selector that filters projects based on selected company IDs
// export const selectProjects = (selectedCompanyIds = []) =>
//   createSelector([selectDomain], (state) => {
//     const allProjects = state.projects || [];

//     if (!selectedCompanyIds.length) return [];

//     return allProjects
//       .filter((project) => selectedCompanyIds.includes(project.companyId))
//       .map((project) => ({
//         value: project._id,
//         label: project.projectCode,
//       }));
//   });